import { RegisteredUsers, Results } from 'src/models/interfaces';

export class DocumentModel {
	id: string;
	data: any;
	collection: string;

	constructor(id: string, data?: any, collection?: string) {
		this.id = id;
		this.collection = collection;
		if (data) {
			this.data = data;
		}
	}
}

export class RegisteredUser extends DocumentModel {
	data: RegisteredUsers;
	collection = 'registeredUsers';
	constructor(id: string = '', data?: RegisteredUsers) {
		super(id, data);
	}
}

export class Result extends DocumentModel {
	data: Results;
	collection = 'results';
	constructor(id: string = '', data?: Results) {
		super(id, data);
	}
}
